import { AceProjektAceProjektEnumsAceProjektStatuscode, GlobalEnumsAcePortalstatus, GlobalEnumsAceTypphase } from "@/api/model-index";
import { AnfrageListDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-list-display-model";
import { AnfrageContract } from "./abstractions/anfrage.contract";

export class ProjektList implements AnfrageContract
{
    protected anfrage: AnfrageListDisplayModel;

    public constructor(anfrage: AnfrageListDisplayModel)
    {
        this.anfrage = anfrage;
    }

    /**
     * Determines whether the anfrage is a draft.
     * 
     * @returns boolean
     */
    public get isDraft(): boolean
    {
        return this.anfrage.status == AceProjektAceProjektEnumsAceProjektStatuscode.Entwurf;
    }

    /**
     * Determines whether the anfrage has been captured.
     * 
     * @returns boolean
     */
    public get isCaptured(): boolean
    {
        return this.anfrage.status == AceProjektAceProjektEnumsAceProjektStatuscode.Erfasst;
    }

    public get isInAudit(): boolean
    {
        return this.anfrage.status == AceProjektAceProjektEnumsAceProjektStatuscode.InPrufung;
    }

    public get isEndorsed(): boolean
    {
        return this.anfrage.status == AceProjektAceProjektEnumsAceProjektStatuscode.Entscheidung;
    }

    public get isRevokable(): boolean
    {
        if (! this.isAntragsphase)
            return false;
        
        return this.isCaptured || this.isInAudit || this.isEndorsed;
    }

    public get isAntragsphase(): boolean
    {
        return this.anfrage.phase?.typ == GlobalEnumsAceTypphase.Standard;
    }

    /**
     * Determines whether the anfrage is marked as revoked.
     * 
     * @returns boolean
     */
    public get markedAsRevoked(): boolean {
        return this.anfrage.status == <number>AceProjektAceProjektEnumsAceProjektStatuscode.Zuruckziehenbeantragt
    }

    /**
     * Marks the anfrage as revoked.
     * 
     * @returns void
     */
    public markAsRevoked(): void {
        this.anfrage.status = <number>AceProjektAceProjektEnumsAceProjektStatuscode.Zuruckziehenbeantragt
    }

    /**
     * Revokes the anfrage.
     * 
     * @returns void
     */
    public revoke(): void {
        throw new Error("Method not implemented.");
    }

    /**
     * Determines whether the anfrage is in progress.
     * 
     * @returns boolean
     */
    public get isInProgress(): boolean {
        return this.anfrage.portalStatus == GlobalEnumsAcePortalstatus.inUberarbeitung;
    }
}